const englishTranslationContent = () => {
  return {
    copy: {
      comma: {
        gpcr: {
          dayOne: 'Fri, 15 Nov',
          dayTwo: 'Sat, 16 Nov',
          dayThree: 'Sun, 17 Nov',
        },
      },
      preSignInPage: {
        firstScreen: `<div class="px-[24px]">
                  <div class="text-center font-aktiv-grotesk font-semibold text-[32px] md:text-[48px] leading-[32px] md:leading-[48px]">Welcome to</div>
                  <div class="flex flex-row justify-center mx-auto items-end">
                    <img src="/assets/images/generations-app.svg" class="w-[190px] md:w-[258px]"/>
                    <span class="font-aktiv-grotesk font-semibold text-[32px] md:text-[48px] leading-[32px] md:leading-[48px]">&nbsp;App</span>
                  </div>
                  <img src="/assets/images/presignin/pre-signin-page-1.png" class="w-auto h-[40vh] md:py-[40px] mx-auto" style="padding-top: 3vh; padding-bottom: 2vh;"/>
                  <div class="text-white w-[90vw] md:w-auto mx-auto text-center font-aktiv-grotesk-medium text-[20px] md:text-[28px] leading-[28px] md:leading-[32px]">
                    Discipling GenerationS to build a
                    <span class="whitespace-nowrap md:whitespace-auto">StronG church</span>\
                  </div>\
                </div>`,
        secondScreen: `<div class="pt-[8px] px-[24px]">\
                <div class="w-[90vw] md:w-[432px] text-center font-aktiv-grotesk font-semibold text-[24px] md:text-[32px] leading-[32px] md:leading-[40px] mx-auto">\
                  Time to grow our churches\
                  YOUNGER and STRONGER!\
                </div>\
                <img src="/assets/images/presignin/pre-signin-page-2.png" class="w-auto h-[40vh] md:py-[40px] mx-auto" style="padding-top: 3vh; padding-bottom: 2vh;" />\
                <div class="text-white w-[90vw] md:w-auto mx-auto text-center font-aktiv-grotesk-medium text-[20px] md:text-[28px] leading-[28px] md:leading-[32px] mx-auto">\
                  Use this app to get the latest \
                  conference updates. \
                </div>\
              </div>`,
        thirdScreen: `<div class="pt-[8px] px-[24px]">\
                <div class="w-[90vw] md:w-[432px] mx-auto text-center font-aktiv-grotesk font-semibold text-[24px] md:text-[32px] leading-[24px] md:leading-[40px] mx-auto">\
                  It doesn’t end with the\
                  conference…\
                </div>\
                <img src="/assets/images/presignin/pre-signin-page-3.png" class="w-auto h-[40vh] md:py-[40px] mx-auto" style="padding-top: 3vh; padding-bottom: 2vh;" />\
                <div class="text-white w-[90vw] md:w-auto mx-auto text-center font-aktiv-grotesk-medium text-[20px] md:text-[28px] leading-[28px] md:leading-[32px] mx-auto">\
                  Continue accessing exclusive \
                  GenerationS and StronG church \
                  resources with this app! \
                </div>\
              </div>\
              </div>`,
        nextButton: 'Next',
        loginButton: 'Login',
      },
      homePage: {
        profileDropdown: {
          profile: 'Profile',
          language: 'Language',
          conference: 'Conference',
          logout: 'Log Out',
        },
        conferenceType: {
          title: 'Conference',
          gpcr: {
            name: 'GenerationS Pastors Conference Regional',
          },
          gpc: {
            name: 'GenerationS Pastors Conference',
          },
          gic: {
            name: 'GenerationS Implementation Community (Europe)',
          },
        },
        mainLayout: {
          topNav: {
            experiences: 'Experiences',
            photoDrop: 'PhotoDrop',
            updates: 'Updates',
          },
          scheduleSection: {
            title: 'Schedule',
            schedulePanel: {
              endOfDay: 'End of Day { day }',
              tillNextTime: 'Till next time!',
              seeYouTomorrow: 'See you tomorrow!',
              seeYouNextYear: 'See you in 2025!',
              viewSessionResources: `Want to review the session resources? <br />Head to the `,
              viewSessionResourcesPage: 'Resources Page',
              seeYouSoon: 'We loved having you with us! See you soon! 🤩',
              cantWaitToSeeYou: 'Hello! We can’t wait to see you soon!',
              // applyNow: "Apply Now",
              happeningNow: 'Happening now, ',
              goToScheduleButton: 'Go to Schedule',
              viewScheduleButton: 'View schedule',
              viewNextDayScheduleButton: 'View next day’s schedule',
            },
          },
          registration: {
            bannerName: 'registration.png',
          },
          worshipSongs: {
            availableOnYoutube: 'Available on YouTube',
            titleImgUrl: '../../../public/assets/images/home/playlist.png',
          },
          kickOffSection: {
            title: `<p class="text-[32px] text-left leading-[40px] text-blue font-aktiv-grotesk-medium pb-4">
                            Before we kick things <br class="hidden lg:block"/>off...
                          </p>`,
            description: `<p class="text-[16px] text-left lg:w-[320px] mx-auto leading-[24px] text-blue pb-5 font-aktiv-grotesk-regular">
                                  Watch this short clip to get a quick overview of what GenerationS is all about!<br />
                                  You'll be all set to receive the full impact of the next 3 days ahead! 😊
                                </p>`,
            downloadVideo: 'Download video',
            downloadThumbnail:
              'https://cdn.generationsmvmt.com/images/app/gpcr-pre-watch-thumbnail-en.jpg',
            downloadLink:
              'https://cdn.generationsmvmt.com/videos/conference-app/gpcr-pre-watch-en.mp4',
          },
          experiences: {},
          usefulLinks: {
            title: 'Useful links',
            links: {
              gettingAround: 'Getting around HOGC 🚶🏻‍♂️',
              mapLink: 'https://cdn.generationsmvmt.com/docs/HOGC-Map.pdf',
              appGuidedTour: 'App Guided Tour',
              giving: 'Giving',
              busSchedule: 'Shuttle bus schedule',
              busSchedulePdf:
                'https://cdn.generationsmvmt.com/docs/GPCR-2024-Shuttle-Bus-Schedule-EN.pdf',
            },
          },
          appGuidedTour: {
            startTour: 'Start Tour',
            skipTour: 'Skip Tour',
            skipButton: 'Skip',
            backButton: 'Back',
            nextButton: 'Next',
            endButton: 'End',
            stepPill: {
              stepText: 'Step',
              ofText: 'of',
            },
            homeTourTextStep0SCS: `
                    <div>
                        <img src="../../../assets/images/guided-tour/HOGC_SG.svg" alt="HOGC" />
                        <br>
                        <div style="text-align:center; margin-left:auto; margin-right:auto; color:#231F20; font-size: 24px; font-weight: 500; line-height: 28px;">Welcome to</div>
                        <img style="padding-bottom:18px;" src="../../../assets/images/gpcr/gpcr-2024-logo-dark.png" alt="Generations" />
                        <div style="padding-bottom:12px; text-align:left; color:#231F20; font-weight: 400; font-size: 16px; line-height: 24px;">The GenerationS Pastors Conference App lets you view your schedule, session materials and experiences.</div>
                        <div style="padding-bottom:24px; text-align:left; color:#231F20; font-weight: 400; font-size: 16px; line-height: 24px;">Let's take a quick tour! </div>
                    </div>
                  `,
            homeTourTextStep0GC: `
                    <div>
                        <img src="../../../assets/images/guided-tour/HOGC_SG.svg" alt="HOGC" />
                        <br>
                        <div style="text-align:center; margin-left:auto; margin-right:auto; color:#231F20; font-size: 24px; font-weight: 500; line-height: 28px;">Welcome to</div>
                        <img style="padding-bottom:18px;" src="../../../assets/images/gpcr/gpcr-2024-logo-dark.png" alt="Generations" />
                        <div style="padding-bottom:12px; text-align:left; color:#231F20; font-weight: 400; font-size: 16px; line-height: 24px;">The GenerationS Pastors Conference App lets you view your schedule, session materials and experiences.</div>
                        <div style="padding-bottom:24px; text-align:left; color:#231F20; font-weight: 400; font-size: 16px; line-height: 24px;">Let's take a quick tour! </div>
                    </div>
                  `,
            homeTourTextStep1: `<span style="text-align:left; color:#231F20; font-size: 20px; line-height: 24px;">Schedule</span> <br> <br>
                      <span style="text-align:left; color:#231F20; font-weight: 400; font-size: 16px; line-height: 24px;">Stay in the loop about the daily schedule throughout the conference!</span> <br>`,
            homeTourTextStep2: `<span style="text-align:left; color:#231F20; font-size: 20px; line-height: 24px;">Experiences</span> <br> <br>
                      <span style="text-align:left; color:#231F20; font-weight: 400; font-size: 16px; line-height: 24px;">Go behind the scenes to see GenerationS and StronG church brought to life. Click here to view your allocated experiences.</span> <br>`,
            homeTourTextStep3: `<span style="text-align:left; color:#231F20; font-size: 20px; line-height: 24px;">PhotoDrop</span> <br> <br>
                      <span style="text-align:left; color:#231F20; font-weight: 400; font-size: 16px; line-height: 24px;">Check out your personalised conference photos here - updated in real-time!</span> <br>`,
            homeTourTextStep4: `<span style="text-align:left; color:#231F20; font-size: 20px; line-height: 24px;">Before we begin...</span> <br> <br>
                      <span style="text-align:left; color:#231F20; font-weight: 400; font-size: 16px; line-height: 24px;">Watch to find out the mindset shifts to start building GenerationS and a strong church</span> <br>`,
            homeTourTextStep5: `<span style="text-align:left; color:#231F20; font-size: 20px; line-height: 24px;">Profile and Settings</span> <br> <br>
                      <span style="text-align:left; color:#231F20; font-weight: 400; font-size: 16px; line-height: 24px;">You can update your contact details here and select your preferred language!</span> <br> <br>`,
            scheduleTourStep1: `<span style="text-align:left; color:#231F20; font-size: 20px; line-height: 24px;">Schedule</span> <br> <br>
                      <span style="text-align:left; color:#231F20; font-weight: 400; font-size: 16px; line-height: 24px;">Access the full conference schedule.</span>`,
            scheduleTourStep2: `<span style="text-align:left; color:#231F20; font-size: 20px; line-height: 24px;">Schedule (Daily View)</span> <br> <br>
                      <span style="text-align:left; color:#231F20; font-weight: 400; font-size: 16px; line-height: 24px;">View the daily session timings and venues.</span>`,
            scheduleTourStep3: `<span style="text-align:left; color:#231F20; font-size: 20px; line-height: 24px;">Session Resources</span> <br> <br>
                      <span style="text-align:left; color:#231F20; font-weight: 400; font-size: 16px; line-height: 24px;">Check out “See session resources” and you’re ready for the session!</span>`,
          },
        },
      },
      languagePage: {
        title: 'Language',
        english: 'English',
        chinese: 'Simplified Chinese',
        thai: 'Thai',
      },
      settingsPage: {
        title: 'Settings',
        general: {
          title: 'General',
          language: 'Language',
          conferenceSelector: 'Conference Selector',
        },
        support: {
          title: 'Support',
          enquiry: 'Enquiry',
          appGuidedTour: 'App Guided Tour',
          privacyPolicy: 'Privacy policy',
          termsOfUse: 'Terms of use',
        },
        logout: 'Logout',
      },
      profilePage: {
        showQr: 'Show QR',
        personalQr: 'Personal QR',
        editProfile: 'Edit Profile',
        addImage: 'Set new photo',
        displayName: `Display Name (required)`,
        emptyName: 'Let us know your name!',
        organization: 'Church / Organization',
        title: 'Title',
        addEmail: 'Add email',
        addSocials: 'Add socials',
        editEmail: 'Edit email',
        editSocials: 'Edit socials',
        email: 'Email',
        showMyEmail: 'Show my email',
        accountLoginEmail: 'Account login email',
        socials: 'Socials',
        socialMedia: {
          addSocialsTitle: 'Add Socials',
          addInstagram: 'Add Instagram',
          addFacebook: 'Add Facebook',
          addX: 'Add X',
          addLinkedIn: 'Add LinkedIn',
        },
        saveChanges: 'Save changes',
        unsavedTitle: 'Discard changes?',
        unsavedBody: "You have unsaved changes. If you leave now, they'll be lost.",
        unsavedKeepEditing: 'Keep editing',
        unsavedDiscard: 'Discard changes',
      },
      announcementPage: {
        title: 'Latest Updates',
        announcementCard: {
          newLabel: 'New',
          today: 'TODAY, ',
        },
      },
      announcementPageGIC: {
        title: 'Updates',
        announcementCard: {
          newLabel: 'New',
          today: 'TODAY, ',
        },
      },
      resourcesPage: {
        title: 'Resources',
        filterBy: 'Filter by',
        filterSection: {
          topics: 'Topics',
          sessions: 'Sessions',
          day: 'Day { i }: ',
          all: 'All',
          session: 'Session',
        },
        searchContent: {
          searchingStringText: `Search results for "{searchTerm}"`,
          noResourcesSearchText: `Your search for "{searchTerm}" didn't return any results.`,
          noOfResourcesFound: `{count} resources found`,
        },
        videoPage: {
          videoChapters: 'Video Chapters',
          yellowTag: {
            exclusive: 'Exclusive',
            audioOnly: 'Audio only',
          },
          shareButton: 'Share',
        },
        description:
          'Welcome to your one-stop hub for all GenerationS & StronG church resources. Use these sermons, videos, tools to grow your church Younger & Stronger.',
        searchBar: 'Search',
        resourceSearch: {
          bookSection: {
            header: 'Book',
          },
          quotesSection: {
            header: 'Quotes',
          },
          suggestionSection: {
            header: 'You may be interested in...',
          },
          bookmarksSection: {
            header: 'My List',
          },
        },
        backToTopSection: {
          otherContentText: 'Interested in other resources?',
          backToTop: 'Back to top',
        },
      },
      sessionResourcesPage: {
        accessLiveInterpretation: 'Live Interpretation',
        sessionResourcesheader: 'Session Resources',
        assets: {
          toolsHeader: 'Tools',
          questionsHeader: 'Discussion Time Questions',
          linksHeader: 'Related Resources',
        },
      },
      experiencePage: {
        title: 'Experiences',
        description:
          'Go behind the scenes and see GenerationS & StronG church principles come to life!',
        note: "📢 Find out which Experience you'll be attending!",
        experienceList: {
          title: 'Each delegate gets to attend 1 of 4 Experiences during GPCR:',
          exp1: 'Prayer Meeting',
          exp2: 'Ministry Debrief',
          exp3: 'Connect Group Experience',
          exp4: 'Dreams & Stories Night',
          note: "📢 Find out which Experience you'll be attending by {date}.",
        },
        allocationPanel: {
          title: 'You’ll be attending',
          protipTitle: '💡Pro-tip',
          protipHeader: 'Make the most of Experiences with these reflection questions:',
          protipQuestion1: 'What can I implement in my church?',
          protipQuestion2: "How can this be applied within my church's context?",
          viewMapButton: 'View map',
          viewMapButtonLink: 'https://cdn.generationsmvmt.com/docs/HOGC-Map.pdf',
          viewFloorplanButton: 'View floorplan',
          viewFloorplanButtonLink:
            'https://cdn.generationsmvmt.com/docs/GPCR-Dream-and-Stories-Night-Floorplan.pdf',
        },
        carousel: {
          title: 'Learn more about all {count} Experiences',
          viewDetailsButton: 'View Details',
        },
      },
      schedulePage: {
        scheduleButton: '3-Day Schedule',
        schedule: 'https://cdn.generationsmvmt.com/docs/GPCR-2024-Schedule-EN.pdf',
        dayOne: {
          day: 'Fri',
          dayNum: '15',
          month: 'Nov',
          announcement: `<div class="text-[16px] leading-[24px] font-aktiv-grotesk-trial text-black">Hello</div>
                📣 Have breakfast before coming! Bring a jacket too!<br>`,
        },
        dayTwo: {
          day: 'Sat',
          dayNum: '16',
          month: 'Nov',
          announcement: `<div class="text-[16px] leading-[24px] font-aktiv-grotesk-trial text-black">It's the weekend! </div>
                📣 Grab a bite before coming!<br>`,
        },
        dayThree: {
          day: 'Sun',
          dayNum: '17',
          month: 'Nov',
          announcement:
            '<div class="text-[16px] leading-[24px] font-aktiv-grotesk-trial text-black">Our last, power-packed day together!</div>📣 Have your breakfast before coming!',
        },
        eventsCard: {
          accessLiveInterpretation: 'Live Interpretation',
          seeSessionResources: 'See session resources',
          viewMapButtonLink: 'https://cdn.generationsmvmt.com/docs/HOGC-Map.pdf',
        },
        // experienceHeader: "Experiences",
        checkAllocation: 'Check Allocation',
        backToTop: 'Back to top',
      },
      photoDropPage: {
        photoDropActionBar: {
          myQR: 'My QR',
          select: 'Select',
          cancel: 'Cancel',
          download: 'Download',
          downloading: 'Downloading',
          noOfSelectedPhotosText: '{ count } photo{s} selected',
        },
        myPhotosTab: {
          tabName: 'For You',
        },
        forEveryoneTab: {
          tabName: 'For Everyone',
          videosTab: 'Videos',
          dayTab: 'Day { i }',
          viewMore: 'View More',
        },
        personalTab: {
          tabName: 'Personal',
          subtitle: 'Grab a friend, grab a photographer and start snapping!',
          qrCodeModal: {
            subtitle: 'Have your photos dropped directly to you!',
            instructions: {
              one: 'Show this QR Code to any Photographers 📸',
              two: 'Grab your friends, get your photo taken, and come back here for the picture!',
            },
          },
        },
        customExperiencesTab: {
          tabName: 'Custom Experiences',
          subtitle: 'Photos from Experiences that you went for will be dropped here! 🎁',
        },
        selectButton: 'Select',
        downloadModal: {
          header: 'Get download link in email',
          description:
            'A link will be sent to your email to download the selected videos and/or photos.',
          sendToMyEmail: 'Send link to my email',
          cancel: 'Cancel',
        },
      },
      teamPage: {
        title: `<div class="font-aktiv-grotesk-medium mx-auto w-full xl:min-w-[360px] text-center xl:text-left text-[24px] leading-[32px]">
                        <span class="font-caveat text-[40px] leading-[32px]">Hello </span>from the Global Team!
                      </div>`,
        backRowText: 'Back row, left to right:',
        backRowNames: {
          pastorMartin: 'Pastor Martin Wong',
          blakeGladd: 'Blake Gadd',
          nataschaBruschweiler: 'Natascha Brüschweiler',
          nadineLeong: 'Nadine Leong',
        },
        frontRowText: 'Front row, left to right:',
        frontRowNames: {
          jamieLee: 'Jamie Lee',
          valerieFifi: 'Valerie Fifi',
          christianHonegger: 'Christian Honegger',
          tanJianMing: 'Tan Jian Ming',
        },
        meetTheFullLeadershipTeam: 'Meet the full leadership team!',
      },
      sideBar: {
        home: 'Home',
        resources: 'Resources',
        schedule: 'Schedule',
        team: 'Team',
        updates: 'Updates',
        termOfUse: 'Terms of Use',
        privacyPolicy: 'Privacy Policy',
      },
      bottomNav: {
        home: 'Home',
        resources: 'Resources',
        schedule: 'Schedule',
        team: 'Team',
        updates: 'Updates',
        more: 'More',
      },
      masterLayout: {
        logoutPopup: {
          message: 'Do you want to log out?',
          continue: 'Continue',
          cancel: 'Cancel',
        },
        newsLetterModal: {
          header: 'Share with your team',
          description: `Fill in their name and email. <br>We will send each of them an invite to the GenS App!`,
          inputNamePlaceholder: "Your friend's name",
          inputEmailPlaceholder: "Your friend's email",
          errorMessage: {
            emptyNameInput: 'Name is required.',
            emptyEmailInput: 'Email is required.',
            notValidEmail: 'Please enter a valid email address.',
          },
          subscribe: 'Send email invite',
          sent: 'Sent',
        },
        filterModal: {
          resetFilters: 'Reset',
          applyFilters: 'Apply filters',
          noItems: 'No items available',
        },
      },
    },
  };
};

export default englishTranslationContent;
